import { Flame, TrendingUp } from "lucide-react";
import type { Streak } from "../streaks";

/** A small accolade chip for an active streak — a rising run gets the trend icon. */
export function StreakBadge({ streak }: { streak: Streak }) {
	const Icon = streak.id === "rising" ? TrendingUp : Flame;
	return (
		<span className="inline-flex items-center gap-1.5 rounded-full border border-semantic-success/40 bg-semantic-success/10 px-2.5 py-1 text-xs font-medium text-semantic-success">
			<Icon className="h-3.5 w-3.5" />
			{streak.text}
		</span>
	);
}
